import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { FormHelperText } from "@mui/material";

const FormTextField = ({
  label,
  value,
  onChange,
  submitted,
  errorMessage,
  type = "text",
  disabled = false,
  required = false,
  hasError = false,
  margin = "normal",
  ...rest
}) => {
  const [error, setError] = useState(false);

  useEffect(() => {
    if (submitted && required && !value) {
      setError(true);
    }
  }, [submitted, required, value]);

  const handleChange = (event) => {
    const inputValue = event;
    onChange(inputValue);
    setError(false);
  };

  return (
    <>
      <TextField
        type={type}
        label={label}
        value={value}
        error={error || hasError}
        margin={margin}
        variant="outlined"
        required={required}
        onChange={handleChange}
        disabled={disabled}
        {...rest}
      />

      {hasError && (
        <FormHelperText error>
          {errorMessage || `${label} is required.`}
        </FormHelperText>
      )}
    </>
  );
};

export default FormTextField;
